import React from 'react';
import { observer } from 'mobx-react';
import CardButtons from 'components/card/card_buttons';
import { DeckUI } from '@seedlang/state';
import { CheckpointCardWrapper } from '@seedlang/hoc';
import CardWrapper from 'components/layout/card_wrapper';
import CardContent from 'components/layout/card_content';
import NextButton from 'components/button/next_button';
import CheckpointCardContent from 'components/card/checkpoint_card_content';

@observer
class CheckpointCard extends React.Component {

  render() {
    return (
      <CardWrapper>
        {
          DeckUI.userIsLoaded && DeckUI.userDeck.hasUserCards &&
            <CardContent>
              <CheckpointCardContent
                card={this.props.card}
                inView={this.props.inView}
                achievementText={this.props.achievementText}
                encouragement={this.props.encouragement}
                languageIndex={this.props.languageIndex}
                toggleLanguage={this.props.toggleLanguage}
                height={DeckUI.layout.contentHeight}
              />
            </CardContent>
        }
        <CardButtons>
          <NextButton
            disabled={!this.props.inView}
            onClick={() => DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard)}
            submitOnEnter
            shortcut='1'
          />
        </CardButtons>
      </CardWrapper>
    );
  }
}

export default CheckpointCardWrapper(CheckpointCard);
